import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

if (typeof window === 'undefined') {
    const mockStorage = {
        getItem: () => null, setItem: () => null, removeItem: () => null,
        clear: () => null, length: 0, key: () => null
    };
    (global as any).window = { localStorage: mockStorage };
    (global as any).localStorage = mockStorage;
} else if (!window.localStorage) {
    const mockStorage = {
        getItem: () => null, setItem: () => null, removeItem: () => null,
        clear: () => null, length: 0, key: () => null
    };
    (window as any).localStorage = mockStorage;
}

// ⚠️ Acá vivía un camino que ADIVINABA el logo de la marca como
// `<TENANT_CDN_URL>/<tenantId>/logo.svg`, y además dejaba esa base cacheada en
// `plp_tenant_cdn_url` para que el anti-FOUC de `index.html` la usara.
//
// Esa convención NO es la nuestra: el CDN que montamos va delante de la API, no
// de un bucket, y las URLs reales son
// `.../api/v1/tenants/<id>/assets/logo/file/?v=<huella>` — con la huella, que es
// lo único que invalida el caché de un año. O sea que el día que alguien pusiera
// la variable `TENANT_CDN_URL` en producción, el splash de TODA marca pasaría a
// pedir un archivo inexistente, y encima el `?v=` desaparecería del camino.
//
// No hace falta reemplazo: el logo del splash sale de `plp_tenant_logo`, que el
// theme service escribe YA RESUELTO (absoluto, con su huella, por el CDN si está
// configurado). En la primera visita no hay nada cacheado y el splash va SIN
// logo a propósito — mostrar uno que puede no ser el de esa marca es peor.

bootstrapApplication(AppComponent, appConfig)
  .catch(() => {}); // No hace nada si hay un error